import { Paper } from '@material-ui/core';
import styled from 'styled-components';
import { ReadinessCheckStatus, ReadinessOrderStatus } from './types';

export const CHECK_COLORS: Record<ReadinessCheckStatus, string> = {
  PASS: '#2e7d32',
  WARN: '#b45309',
  FAIL: '#c62828',
};

export const ORDER_STATUS_COLORS: Record<ReadinessOrderStatus, string> = {
  ACCEPTED: '#2e7d32',
  PENDING: '#b45309',
  NONE: '#c62828',
  REJECTED: '#ad1457',
  EXPIRED: '#6d4c41',
  CANCELLED: '#616161',
};

export const CheckGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 12px;
  margin: 12px 0;
`;

export const CheckCard = styled(Paper)<{ $color: string }>`
  padding: 8px 12px;
  border-left: 4px solid ${({ $color }) => $color};
`;

export const CheckValue = styled.span<{ $color: string }>`
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.3;
  color: ${({ $color }) => $color};
`;

export const Pill = styled.span<{ $color: string }>`
  display: inline-block;
  padding: 0 8px;
  border: 1px solid ${({ $color }) => $color};
  border-radius: 10px;
  color: ${({ $color }) => $color};
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
`;

export const Dot = styled.span<{ $color: string }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-left: 8px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`;

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
`;

export const FilterField = styled.div`
  width: 200px;
`;
